import { type CSSProperties, forwardRef } from 'react';

import { Box as MantineBox, type BoxProps as MantineBoxProps, createPolymorphicComponent } from '@mantine/core';

import { omitUndefined } from '@/new_src/view/components/utils/omitUndefined';
import { resolveColorTokens } from '@/new_src/view/components/utils/resolveColorTokens';

type ExtraStyleProps = {
  zIndex?: CSSProperties['zIndex'];
  overflow?: CSSProperties['overflow'];
  overflowX?: CSSProperties['overflowX'];
  shrink?: CSSProperties['flexShrink'];
  radius?: CSSProperties['borderRadius'];
  whiteSpace?: CSSProperties['whiteSpace'];
  boxSizing?: CSSProperties['boxSizing'];
  bdb?: CSSProperties['borderBottom'];
  bdr?: CSSProperties['borderRight'];
};

export type BoxProps = MantineBoxProps & ExtraStyleProps;

const _Box = forwardRef<HTMLDivElement, BoxProps>(
  ({ zIndex, overflow, overflowX, shrink, radius, whiteSpace, boxSizing, bdb, bdr, style, ...rest }, ref) => (
    <MantineBox
      ref={ref}
      style={[
        omitUndefined({
          zIndex,
          overflow,
          overflowX,
          flexShrink: shrink,
          borderRadius: radius,
          whiteSpace,
          boxSizing,
          borderBottom: typeof bdb === 'string' ? resolveColorTokens(bdb) : bdb,
          borderRight: typeof bdr === 'string' ? resolveColorTokens(bdr) : bdr,
        }),
        style,
      ]}
      {...rest}
    />
  )
);

_Box.displayName = 'Box';

export const Box = createPolymorphicComponent<'div', BoxProps>(_Box);
